/**
 * Testimonios de facilitadores de breathwork (DPS46).
 * role y location son opcionales: completarlos cuando estén confirmados.
 */
export type Voice = {
  quote: string
  name: string
  role?: string
  location?: string
}

export const voices: Voice[] = [
  {
    quote:
      'I used to spend hours mapping out every session. With Breathwork Session Ready, I can walk in and actually breathe myself. The phases and wording make it feel natural, and the integration guidance keeps clients grounded for days afterward.',
    name: 'Jessica Miller',
  },
  {
    quote:
      'The minute-by-minute structure is a game-changer for circles and workshops. I’ve run sessions that felt confident and cohesive instead of improvised. My participants also mention feeling held all the way through, especially during the Ground phase.',
    name: 'Michael Chen',
  },
  {
    quote:
      'As someone who leads 1:1 and retreats, I needed something that scaled. This pack gives me a clear breath curve and solid aftercare. I finally feel like my sessions have a signature flow—even when the theme changes.',
    name: 'Ashley Johnson',
  },
]
